import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import MyHead from '../../components/MyHead';

const TermsAndConditionPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <MyHead />

      <div
        className="section full text-white"
        style={{
          background: `linear-gradient(to bottom, rgba(0, 20, 26, 0.1), rgba(0, 20, 26, 0.25)), url("../../img/hero-std-page.jpg")`
        }}
      >
        <div className="section-wrapper section-y-sm flex justify-center">
          <h1 className="h1">{t('P_TERMS_CONDITIONS.TITLE')}</h1>
        </div>
      </div>

      <div className="section narrow">
        <div className="text-center font-bold text-base mb-8">
          {t('P_TERMS_CONDITIONS.SUBTITLE')}
        </div>
        {/* 0 */}
        <div className="paragraph">
          <p>{t('P_TERMS_CONDITIONS.0')}</p>
          <ol>
            <li>{t('P_TERMS_CONDITIONS.0_1')}</li>
            <li>{t('P_TERMS_CONDITIONS.0_2')}</li>
            <li>{t('P_TERMS_CONDITIONS.0_3')}</li>
            <li>{t('P_TERMS_CONDITIONS.0_4')}</li>
            <li>{t('P_TERMS_CONDITIONS.0_5')}</li>
            <li>{t('P_TERMS_CONDITIONS.0_6')}</li>
          </ol>
        </div>
        {/* 1 */}
        <div className="paragraph">
          <table className="table-auto">
            <tbody>
              <tr className="font-bold">
                <td>1.</td>
                <td>{t('P_TERMS_CONDITIONS.1')}</td>
              </tr>
              <tr>
                <td>1.1</td>
                <td>{t('P_TERMS_CONDITIONS.1_1')}</td>
              </tr>
              <tr>
                <td>1.2</td>
                <td>{t('P_TERMS_CONDITIONS.1_2')}</td>
              </tr>
              <tr>
                <td>1.3</td>
                <td>{t('P_TERMS_CONDITIONS.1_3')}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* 2 */}
        <div className="paragraph">
          <table className="table-auto">
            <tbody>
              <tr className="font-bold">
                <td>2.</td>
                <td>{t('P_TERMS_CONDITIONS.2')}</td>
              </tr>
              <tr>
                <td>2.1</td>
                <td>{t('P_TERMS_CONDITIONS.2_1')}</td>
              </tr>
              <tr>
                <td>2.2</td>
                <td>{t('P_TERMS_CONDITIONS.2_2')}</td>
              </tr>
              <tr>
                <td>2.3</td>
                <td>{t('P_TERMS_CONDITIONS.2_3')}</td>
              </tr>
              <tr>
                <td>2.4</td>
                <td>{t('P_TERMS_CONDITIONS.2_4')}</td>
              </tr>
              <tr>
                <td>2.5</td>
                <td>{t('P_TERMS_CONDITIONS.2_5')}</td>
              </tr>
              <tr>
                <td>2.6</td>
                <td>{t('P_TERMS_CONDITIONS.2_6')}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* 3 */}
        <div className="paragraph">
          <table className="table-auto">
            <tbody>
              <tr className="font-bold">
                <td>3.</td>
                <td>{t('P_TERMS_CONDITIONS.3')}</td>
              </tr>
              <tr>
                <td>3.1</td>
                <td>{t('P_TERMS_CONDITIONS.3_1')}</td>
              </tr>
              <tr>
                <td>3.3</td>
                <td>{t('P_TERMS_CONDITIONS.3_2')}</td>
              </tr>
              <tr>
                <td>3.3</td>
                <td>{t('P_TERMS_CONDITIONS.3_3')}</td>
              </tr>
              <tr>
                <td>3.4</td>
                <td>{t('P_TERMS_CONDITIONS.3_4')}</td>
              </tr>
              <tr>
                <td>3.5</td>
                <td>{t('P_TERMS_CONDITIONS.3_5')}</td>
              </tr>
              <tr>
                <td>3.6</td>
                <td>{t('P_TERMS_CONDITIONS.3_6')}</td>
              </tr>
              <tr>
                <td>3.7</td>
                <td>{t('P_TERMS_CONDITIONS.3_7')}</td>
              </tr>
              <tr>
                <td>3.8</td>
                <td>{t('P_TERMS_CONDITIONS.3_8')}</td>
              </tr>
              <tr>
                <td>3.9</td>
                <td>{t('P_TERMS_CONDITIONS.3_9')}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* 4 */}
        <div className="paragraph">
          <table className="table-auto">
            <tbody>
              <tr className="font-bold">
                <td>4.</td>
                <td>{t('P_TERMS_CONDITIONS.4')}</td>
              </tr>
              <tr>
                <td>4.1</td>
                <td>{t('P_TERMS_CONDITIONS.4_1')}</td>
              </tr>
              <tr>
                <td>4.2</td>
                <td>{t('P_TERMS_CONDITIONS.4_2')}</td>
              </tr>
              <tr>
                <td>4.3</td>
                <td>{t('P_TERMS_CONDITIONS.4_3')}</td>
              </tr>
              <tr>
                <td>4.4</td>
                <td>{t('P_TERMS_CONDITIONS.4_4')}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* 5 */}
        <div className="paragraph">
          <table className="table-auto">
            <tbody>
              <tr className="font-bold">
                <td>5.</td>
                <td>{t('P_TERMS_CONDITIONS.5')}</td>
              </tr>
              <tr>
                <td>5.1</td>
                <td>{t('P_TERMS_CONDITIONS.5_1')}</td>
              </tr>
              <tr>
                <td>5.2</td>
                <td>{t('P_TERMS_CONDITIONS.5_2')}</td>
              </tr>
              <tr>
                <td>5.3</td>
                <td>{t('P_TERMS_CONDITIONS.5_3')}</td>
              </tr>
              <tr>
                <td>5.4</td>
                <td>{t('P_TERMS_CONDITIONS.5_4')}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* 6 */}
        <div className="paragraph">
          <table className="table-auto">
            <tbody>
              <tr className="font-bold">
                <td>6.</td>
                <td>{t('P_TERMS_CONDITIONS.6')}</td>
              </tr>
              <tr>
                <td>6.1</td>
                <td>{t('P_TERMS_CONDITIONS.6_1')}</td>
              </tr>
              <tr>
                <td>6.2</td>
                <td>{t('P_TERMS_CONDITIONS.6_2')}</td>
              </tr>
              <tr>
                <td>6.3</td>
                <td>{t('P_TERMS_CONDITIONS.6_3')}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* 7 */}
        <div className="paragraph">
          <table className="table-auto">
            <tbody>
              <tr className="font-bold">
                <td>7.</td>
                <td>{t('P_TERMS_CONDITIONS.7')}</td>
              </tr>
              <tr>
                <td>7.1</td>
                <td>{t('P_TERMS_CONDITIONS.7_1')}</td>
              </tr>
              <tr>
                <td>7.2</td>
                <td>{t('P_TERMS_CONDITIONS.7_2')}</td>
              </tr>
              <tr>
                <td>7.3</td>
                <td>{t('P_TERMS_CONDITIONS.7_3')}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* 8 */}
        <div className="paragraph">
          <table className="table-auto">
            <tbody>
              <tr className="font-bold">
                <td>8.</td>
                <td>{t('P_TERMS_CONDITIONS.8')}</td>
              </tr>
              <tr>
                <td>8.1</td>
                <td>{t('P_TERMS_CONDITIONS.8_1')}</td>
              </tr>
              <tr>
                <td>8.2</td>
                <td>{t('P_TERMS_CONDITIONS.8_2')}</td>
              </tr>
              <tr>
                <td>8.3</td>
                <td>{t('P_TERMS_CONDITIONS.8_3')}</td>
              </tr>
              <tr>
                <td>8.4</td>
                <td>{t('P_TERMS_CONDITIONS.8_4')}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* 9 */}
        <div className="paragraph">
          <table className="table-auto">
            <tbody>
              <tr className="font-bold">
                <td>9.</td>
                <td>{t('P_TERMS_CONDITIONS.9')}</td>
              </tr>
              <tr>
                <td>9.1</td>
                <td>{t('P_TERMS_CONDITIONS.9_1')}</td>
              </tr>
              <tr>
                <td>9.2</td>
                <td>{t('P_TERMS_CONDITIONS.9_2')}</td>
              </tr>
              <tr>
                <td>9.3</td>
                <td>{t('P_TERMS_CONDITIONS.9_3')}</td>
              </tr>
              <tr>
                <td>9.4</td>
                <td>{t('P_TERMS_CONDITIONS.9_4')}</td>
              </tr>
              <tr>
                <td>9.5</td>
                <td>{t('P_TERMS_CONDITIONS.9_5')}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* 10 */}
        <div className="paragraph">
          <table className="table-auto">
            <tbody>
              <tr className="font-bold">
                <td>10.</td>
                <td>{t('P_TERMS_CONDITIONS.10')}</td>
              </tr>
              <tr>
                <td>10.1</td>
                <td>{t('P_TERMS_CONDITIONS.10_1')}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* 11 */}
        <div className="paragraph">
          <table className="table-auto">
            <tbody>
              <tr className="font-bold">
                <td>11.</td>
                <td>{t('P_TERMS_CONDITIONS.11')}</td>
              </tr>
              <tr>
                <td>11.1</td>
                <td>{t('P_TERMS_CONDITIONS.11_1')}</td>
              </tr>
              <tr>
                <td>11.2</td>
                <td>{t('P_TERMS_CONDITIONS.11_2')}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* 12 */}
        <div className="paragraph">
          <table className="table-auto">
            <tbody>
              <tr className="font-bold">
                <td>12.</td>
                <td>{t('P_TERMS_CONDITIONS.12')}</td>
              </tr>
              <tr>
                <td>12.1</td>
                <td>{t('P_TERMS_CONDITIONS.12_1')}</td>
              </tr>
              <tr>
                <td>12.2</td>
                <td>{t('P_TERMS_CONDITIONS.12_2')}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* 13 */}
        <div className="paragraph">
          <table className="table-auto">
            <tbody>
              <tr className="font-bold">
                <td>13.</td>
                <td>{t('P_TERMS_CONDITIONS.13')}</td>
              </tr>
              <tr>
                <td>13.1</td>
                <td>{t('P_TERMS_CONDITIONS.13_1')}</td>
              </tr>
              <tr>
                <td>13.2</td>
                <td>{t('P_TERMS_CONDITIONS.13_2')}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* 14 */}
        <div className="paragraph">
          <table className="table-auto">
            <tbody>
              <tr className="font-bold">
                <td>14.</td>
                <td>{t('P_TERMS_CONDITIONS.14')}</td>
              </tr>
              <tr>
                <td>14.1</td>
                <td>{t('P_TERMS_CONDITIONS.14_1')}</td>
              </tr>
              <tr>
                <td>14.2</td>
                <td>{t('P_TERMS_CONDITIONS.14_2')}</td>
              </tr>
              <tr>
                <td>14.3</td>
                <td>{t('P_TERMS_CONDITIONS.14_3')}</td>
              </tr>
              <tr>
                <td>14.4</td>
                <td>{t('P_TERMS_CONDITIONS.14_4')}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* 15 */}
        <div className="paragraph">
          <table className="table-auto">
            <tbody>
              <tr className="font-bold">
                <td>15.</td>
                <td>{t('P_TERMS_CONDITIONS.15')}</td>
              </tr>
              <tr>
                <td>15.1</td>
                <td>{t('P_TERMS_CONDITIONS.15_1')}</td>
              </tr>
              <tr>
                <td>15.2</td>
                <td>{t('P_TERMS_CONDITIONS.15_2')}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Fragment>
  );
};

export default TermsAndConditionPage;
